import axios from "axios";
import { useEffect, useState } from "react";
import useSWR from "swr";
import { WEB_BLOG_ROOT_URL } from "../helpers";

export interface IWebNews {
	posts: [];
	setPosts: React.Dispatch<React.SetStateAction<[]>>;
	currentNewsListScrollPosition: number;
	setCurrentNewsListScrollPosition: React.Dispatch<
		React.SetStateAction<number>
	>;
	setSearchTerm: React.Dispatch<React.SetStateAction<string | null>>;
	searchTerm: string | null;
	resetNewsState: () => void;
	currentPageNum: number;
	setCurrentPageNum: React.Dispatch<React.SetStateAction<number>>;
	perPage: number;
	setPerPage: React.Dispatch<React.SetStateAction<number>>;
	totalPages: number;
	setTotalPages: React.Dispatch<React.SetStateAction<number>>;
	totalPosts: number;
	setTotalPosts: React.Dispatch<React.SetStateAction<number>>;
	error: Error | null;
	isLoading: boolean;
}

export const useWebNews = (): IWebNews => {
	const [perPage, setPerPage] = useState(6);
	const [posts, setPosts] = useState<[]>([]);
	const [currentNewsListScrollPosition, setCurrentNewsListScrollPosition] =
		useState<number>(0);
	const [searchTerm, setSearchTerm] = useState<string | null>(null);
	const [currentPageNum, setCurrentPageNum] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [totalPosts, setTotalPosts] = useState(0);

	const { data, error, isLoading } = useSWR<{
		data: [];
		headers: Record<string, string>;
	}>(
		`${WEB_BLOG_ROOT_URL}wp/v2/posts?${
			searchTerm ? `search=${searchTerm}&` : ""
		}per_page=${perPage}&page=${currentPageNum}&categories=${
			searchTerm ? "1360,1359" : "1360"
		}`,
		axios
	);

	const resetNewsState = () => {
		setCurrentPageNum(1);
		setSearchTerm(null);
		setCurrentNewsListScrollPosition(0);
	};

	useEffect(() => {
		data?.data && setPosts(data.data);
		if (data?.headers) {
			setTotalPages(parseInt(data.headers["x-wp-totalpages"]) || 0);
			setTotalPosts(parseInt(data.headers["x-wp-total"]) || 0);
		}
	}, [data]);

	return {
		perPage,
		setPerPage,
		posts,
		setPosts,
		currentNewsListScrollPosition,
		setCurrentNewsListScrollPosition,
		totalPages,
		setTotalPages,
		totalPosts,
		setTotalPosts,
		searchTerm,
		setSearchTerm,
		currentPageNum,
		setCurrentPageNum,
		resetNewsState,
		error,
		isLoading
	};
};
